/**
 * Nilai enum dari API, dalam bahasa orang.
 *
 * KENAPA ADA PENGAMAN. `t()` mengembalikan KUNCINYA saat tidak ketemu, jadi nilai enum
 * baru yang belum diterjemahkan akan tampil di layar sebagai `st.sesuatu` — terbaca
 * seperti kerusakan, dan lebih buruk daripada nilai aslinya. `periksa_kunci.mjs` tidak
 * bisa menangkapnya karena kuncinya dirakit saat jalan, bukan ditulis harfiah.
 *
 * Jadi kalau terjemahannya tidak ada, yang ditampilkan nilai ASLINYA — `pending_approval`
 * memang jelek, tapi ia setidaknya menyebut sesuatu yang bisa dicari di kode.
 *
 * Ini bukan alasan untuk tidak menerjemahkan: ia jaring, bukan kebijakan.
 */
export function istilah(t, awalan, nilai, bawaan = '—') {
  if (nilai === null || nilai === undefined || nilai === '') return bawaan
  const kunci = `${awalan}.${nilai}`
  const teks = t(kunci)
  return teks === kunci ? String(nilai) : teks
}
